module.exports = __webpack_public_path__ + "static/media/ic-angle.f4f26c2c.svg";